import { useRef, useEffect } from 'react';

/**
 * A way to easily get a place where to put your timeout in order to gracefully clear it on component unmount
 * If we don't clear a timeout, we'll get an accidental memory leak if the timeout is still running when the component unmounts.
 *
 * @returns a ref that can be used in your component. For example:
 *
 * const timeoutRef = useGetTimeoutRef();
 * timeoutRef.current = setTimeout(() => {console.log('yo'), 500})`
 *
 */
export function useGetTimeoutRef() {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    const curr = timeoutRef.current;
    return () => {
      if (curr) {
        clearTimeout(curr);
      }
    };
  }, []);

  return timeoutRef;
}
